import React, { useEffect } from 'react';
import { EnrolledStudentLogin } from '../Student/EnrolledStudentLogin';
import { TeacherLogin } from '../Teacher/TeacherLogin';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { routeIDs } from '../../Routes/RouteIds.routes';

export const Login = () => {
  const [searchParams] = useSearchParams();
  const role = searchParams.get('role') ?? '';
  const navigate = useNavigate();

  useEffect(() => {
    if (!role) {
      navigate(routeIDs.ROLE_SELECTION_SCREEN);
    }
  }, [role]);

  const renderLoginComponent = () => {
    if (role === 'student') {
      return <EnrolledStudentLogin />;
    } else if (role === 'teacher') {
      return <TeacherLogin />;
    }
    return null;
  };

  return <>{renderLoginComponent()}</>;
};
